// extracted by mini-css-extract-plugin
export default {"container":"y9Ow7","checkoutBtnContainer":"G2uQh","bagItems":"NcVKL","bagItem":"t6tMd","loaderContainer":"O7u1+"};